import { Button, Tooltip } from '@mui/material';
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { deleteSliderByIdFn, getSliderFn } from '../../Services/Slider';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { imageFormat } from '../../Config/baseUrl';
import DOMPurify from 'dompurify';
import { deleteImagesFn, getImagesFn } from '../../Services/Images';
import AddImages from './AddImages';

const ImagesComponent = () => {
    const navigate = useNavigate();

    const { data: getSliderResponse, refetch } = useQuery({
        queryKey: "get-iamges",
        queryFn: getImagesFn
    });

    const { mutate: deleteSlider } = useMutation(deleteImagesFn, {
        onSuccess: (response) => {
            if (response?.data?.response_code === 200) {
                toast.success("Deleted Successfully");
                refetch();
            }
        }
    });

    const deleteHandle = (id) => {
        const formData = new FormData();
        formData.append("image_id", id);
        deleteSlider(formData);
    };

    return (
        <div>
            <p className="my-3 text-5xl text-center text-blue-900 underline">Images</p>
            <div className="flex justify-end item-center w-[100%]">
          
                    <div className="text-xl font-bold !text-gray-600 p-3">
                       <AddImages  refetch={refetch}/>
                    </div>
        
            </div>
            <div className="overflow-x-auto mt-6">
            <table className="min-w-full border border-gray-300 rounded-lg">
  <thead className="bg-gray-100">
    <tr>
      <th className="border px-4 py-2 text-center">#</th>
      <th className="border px-4 py-2 text-center">Title</th>
      <th className="border px-4 py-2 text-center">Preview</th>
      <th className="border px-4 py-2 text-center">Copy URL</th>
      <th className="border px-4 py-2 text-center">Action</th>
    </tr>
  </thead>

  <tbody>
    {getSliderResponse?.data?.data?.map((item,index) => (
      <tr key={item.id} className="hover:bg-gray-50">

        {/* ID */}
        <td className="border px-4 py-1 text-center">
          {index+1}
        </td>

        {/* Title */}
        <td className="border px-4 py-1 font-medium text-center">
          {item.title}
        </td>

        {/* Small Image */}
        <td className="border px-4 py-1 flex items-center justify-center">
        <Tooltip  title="click to Preview"  arrow>
          <img
            src={item.image}
            alt={item.title}
            onClick={() => window.open(item?.image, "_blank")}
            className="w-8 h-8 rounded object-cover border cursor-pointer"
            onError={(e) => {
              e.target.src =
                "https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png";
            }}
          />
          </Tooltip>
        </td>

        {/* Copy Button */}
        <td className="border px-4 py-1 text-center">
          <button
            onClick={() => {
              navigator?.clipboard?.writeText(item?.image);
              toast.success("Link Copied");
            }}
            className="px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Copy
          </button>
        </td>

        <td className="border px-4 py-1 text-center">
          <button
            onClick={() => deleteHandle(item.id)}
            className="px-3 py-1 text-sm bg-red-600 text-white rounded hover:bg-red-700"
          >
            Delete
          </button>
        </td>

      </tr>
    ))}
  </tbody>
</table>

</div>

        </div>
    );
};

export default ImagesComponent;
